import { createFileRoute } from '@tanstack/react-router'
import { Salaries } from '../screens/Salaries'

export const Route = createFileRoute('/salaries')({
  component: Salaries,
})
